/**
 * Holi coloring pages — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_shivratri_holi`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const holiColoringPagesPack: ToilePack = {
    slug: 'holi-coloring-pages',
    category: 'faith',
    name: 'Holi coloring pages',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'children', label: 'Children playing', subject: 'two children with a pichkari and a plate of colour powder, splash shapes round them left open to colour in'},
        {key: 'gujiya', label: 'Holi treats', subject: 'a festival table of a plate of gujiya, glasses of thandai, a pichkari and three pots of gulal, each shape outlined large'},
        {key: 'prahlad', label: 'Prahlad and Holika', subject: 'the young Prahlad sitting calm with folded hands in the lap of Holika amid the flames of the pyre, the fire drawn as big open curls'},
    ],
    styles: [
        {key: 'simple', label: 'Simple', style: 'drawn for preschoolers with extra-thick uniform outlines and only a few big shapes', palette: 'black ink only', framing: 'the full page used, the scene large and centered with a white margin'},
        {key: 'cartoon', label: 'Cartoon', style: 'drawn in a friendly cartoon manner with rounded shapes, chunky outlines and big cheerful eyes', palette: 'black ink only', framing: 'the full page used, the scene centered with a white margin'},
        {key: 'border', label: 'Flower border', style: 'drawn in a medium even line inside an ornamental frame of marigolds, paisleys and splash shapes running round the page', palette: 'black ink only', framing: 'the full page used, the scene inside the border with a white margin'},
    ],
    directions: ['Krishna', 'elephant', 'drums'],
    directionHint: 'try: Krishna',
    seo: {
        title: 'Holi coloring pages: play, festival treats, Prahlad',
        metaDescription: 'Nine printable Holi coloring pages for children: colour play, festival treats and the story of Prahlad, in three line styles for different ages.',
        h1: 'Holi coloring pages: children playing, festival treats, Prahlad and Holika',
        tagline: 'Nine black line pages on white, three scenes in three drawing styles for different ages.',
        intro: "Printable Holi coloring pages for children at home, at school or in a Sunday class. Black outlines on white, with large open shapes to fill: two children playing with a pichkari, a festival table of gujiya and thandai, and Prahlad with folded hands among the flames of Holika's pyre. The styles are simple lines for preschoolers, a cartoon manner and a flower border. Type a different subject, such as Krishna or drums, and the same styles carry it.",
        useCases: [
            'A printed sheet for a child at home',
            'A Sunday class activity in the week of Holi',
            'A school activity for the festival week',
            'A story-time page on Prahlad and Holika',
        ],
        faq: [
            {q: 'Is the page ready to print?', a: 'Yes. Each page is black line art on pure white, with no grey tones and no colour, so it prints cleanly.'},
            {q: 'Which page suits the youngest children?', a: 'The simple style has extra-thick outlines and only a few big shapes, drawn for preschoolers.'},
            {q: 'What is the Prahlad page about?', a: "It shows the young Prahlad with folded hands among the flames of Holika's pyre, the story that the Holika Dahan bonfire marks."},
        ],
    },
}
